import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useAuthStore } from '@/stores/auth'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' // הסגנון של פס הטעינה

// NProgress.configure({ showSpinner: false })

// כותרת מסמך ברירת מחדל
const defaultTitle = 'מקצוען בקליק'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
      meta: {
        title: 'התחברות'
      }
    },
    {
      path: '/customers',
      name: 'customers',
      component: () => import('../views/CustomersView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/customers/:id',
      name: 'customer',
      component: () => import('../views/CustomerView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: () => import('../views/JobsView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/jobs/:id',
      name: 'job',
      component: () => import('../views/JobView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/jobs/new',
      name: 'new-job',
      component: () => import('../views/NewJobView.vue'),
      meta: {
        requiresAuth: true, // דורש אימות
        title: 'יצירת עבודה חדשה' // כותרת לדפדפן
      }
    },
    {
      path: '/jobs/quick-schedule',
      name: 'quick-schedule-job',
      component: () => import('../views/QuickScheduleView.vue'), // קומפוננטה חדשה
      meta: {
        requiresAuth: true,
        title: 'קביעת מועד לעבודה' // כותרת מתאימה יותר
      }
    },
    {
      path: '/jobTemplates',
      name: 'jobTemplates',
      component: () => import('../views/JobTemplatesView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/visits',
      name: 'visits',
      component: () => import('../views/VisitsView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/payments',
      name: 'payments',
      component: () => import('../views/PaymentsView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/inventoryItemSimples',
      name: 'inventoryItemSimples',
      component: () => import('../views/InventoryItemSimplesView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/handle-shared-contact', // חייב להיות זהה ל-action ב-manifest
      name: 'handle-shared-contact',
      component: () => import('../views/HandleShareView.vue'), // קומפוננטה חדשה לטיפול בשיתוף
      meta: {
        requiresAuth: true // ודא שהמשתמש מחובר
      }
    },
    {
      path: '/daily-plan', // יומן ביקורים
      name: 'daily-plan',
      component: () => import('../components/VisitPeriodList.vue'), // Lazy load the new component
      meta: {
        requiresAuth: true,
        title: 'תכנון שבועי'
      }
    },
    {
      path: '/inventoryMovements',
      name: 'inventoryMovements',
      component: () => import('../views/InventoryMovementsView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/quotes',
      name: 'quotes',
      component: () => import('../views/QuotesView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/quotes/:id',
      name: 'quote',
      component: () => import('../views/QuoteView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('../views/NotFoundView.vue')
    },
    {
      path: '/areas',
      name: 'areas',
      component: () => import('../views/AreasView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/jobCategories',
      name: 'jobCategories',
      component: () => import('../views/JobCategoriesView.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  // console.log(
  //   `Router Guard: Navigating to ${to.path}. Requires Auth: ${requiresAuth}. Initial Check Done: ${authStore.initialCheckDone}. Is Authenticated: ${authStore.isAuthenticated}`
  // )

  // --- בצע בדיקה ראשונית רק אם היא לא בוצעה עדיין ---
  if (!authStore.initialCheckDone) {
    // console.log('Router Guard: Initial check not done, attempting authentication...')
    await authStore.attemptInitialAuth() // הפונקציה תעדכן את initialCheckDone ואת isAuthenticated
    // console.log(
    //   `Router Guard: Initial check finished. Is Authenticated after check: ${authStore.isAuthenticated}`
    // )
  }
  // --- סוף הבדיקה הראשונית ---

  // קבל את סטטוס האימות העדכני (אחרי שהבדיקה אולי רצה)
  const isAuthenticated = authStore.isAuthenticated

  // קבל החלטה לגבי הניווט
  if (requiresAuth) {
    // אם הנתיב דורש אימות
    if (isAuthenticated) {
      // console.log('Router Guard: Auth required and user IS authenticated. Allowing.')
      next() // מאומת -> אפשר להמשיך
    } else {
      // דורש אימות, אבל לא מאומת (גם אחרי הבדיקה) -> הפנה להתחברות
      // console.log(
      //   'Router Guard: Auth required and user is NOT authenticated. Redirecting to login.'
      // )
      if (to.name !== 'login') {
        localStorage.setItem('lastPath', to.fullPath)
        // console.log('lastPath saved:', to.fullPath)
      }
      next({ name: 'login' })
    }
  } else {
    // נתיב ציבורי
    if (to.name === 'login' && isAuthenticated) {
      // אם מנסים לגשת לדף התחברות כשכבר מחוברים -> הפנה לדף הבית
      // console.log(
      //   'Router Guard: Authenticated user trying to access login page. Redirecting to home.'
      // )
      next({ name: 'home' })
    } else {
      // נתיב ציבורי, או דף התחברות כשלא מחוברים -> אפשר להמשיך
      // console.log('Router Guard: Public route. Allowing.')
      next()
    }
  }
})

router.beforeEach((to) => {
  if (to.meta?.title) {
    document.title = `${defaultTitle} | ${to.meta.title}`
  } else {
    document.title = defaultTitle
  }
})

export default router
